export default "__VITE_ASSET__DbBCcVk2__"